import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { setKey, session } from "../store/actions";
import { connect } from "react-redux";
import { swalSuccess } from "../utils/swal";
import settingService from '../services/setting';
import Switch from "react-switch";

function ManageAdSense({ session }) {
    const { t } = useTranslation();
    const [settings, setSettings] = useState({
        active: false,
        clientId: '',
        slotId: '',
        format: 'auto',
        fullWidthResponsive: true,
        frequency: 6
    });

    useEffect(() => {
        settingService.get().then(res => {
            if (res.data && res.data.googleAdSense) {
                setSettings(res.data.googleAdSense);
            }
        });
    }, []);

    const handleChange = (key, value) => {
        setSettings({ ...settings, [key]: value });
    };

    const handleSave = () => {
        settingService.updateGoogleAdSense(session.token, settings).then(() => {
            swalSuccess(t("adsense_updated"));
        });
    };

    return (
        <div className="container mt-4">
            <h3>{t("manage_adsense_title")}</h3>
            <hr />

            <div className="card p-4">
                <div className="form-group d-flex align-items-center">
                    <label className="mr-3 mb-0">{t("enable_adsense")}</label>
                    <Switch onChange={val => handleChange('active', val)} checked={settings.active} />
                </div>

                <div className="form-group">
                    <label>{t("adsense_client_id")}</label>
                    <input
                        className="form-control"
                        value={settings.clientId}
                        onChange={e => handleChange('clientId', e.target.value)}
                        placeholder="ca-pub-XXXXXXXXXXXXXXXX"
                    />
                </div>

                <div className="form-group">
                    <label>{t("adsense_slot_id")}</label>
                    <input
                        className="form-control"
                        value={settings.slotId}
                        onChange={e => handleChange('slotId', e.target.value)}
                        placeholder="XXXXXXXXXX"
                    />
                </div>

                <div className="form-group">
                    <label>{t("adsense_frequency")}</label>
                    <input
                        type="number"
                        className="form-control"
                        value={settings.frequency}
                        onChange={e => handleChange('frequency', Number(e.target.value))}
                    />
                    <small className="text-muted">{t("adsense_frequency_help", { count: settings.frequency })}</small>
                </div>

                <hr />
                <button className="btn btn-primary" onClick={handleSave}>{t("save_settings")}</button>
            </div>
        </div>
    );
}

const mapStateToProps = store => ({ session: store.session });
export default connect(mapStateToProps)(ManageAdSense);
